
import Badge from 'vux/src/components/badge/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import OrderAll from '../../../components/order/OrderAll'
import OrderAudit from '../../../components/order/OrderAudit'
import OrderRefund from '../../../components/order/OrderRefund'
import OrderConfirm from '../../../components/order/OrderConfirm'
import OrderCheckIn from '../../../components/order/OrderCheckIn'

export default {
name: "List",
directives: {
TransferDom
},
components: {
Badge,
Flexbox,
FlexboxItem,
Sticky,
Tab,
TabItem,
Search,
Group,
Cell,
XButton,
Confirm,
XDialog,
OrderAll,
OrderAudit,
OrderRefund,
OrderConfirm,
OrderCheckIn
},

watch: {
'currentTab': function () {
},
},

computed: {
currentTabComponent: function () {
return 'order-' + this.currentTabType.toLowerCase()
}
},
data() {
return {
currentTab: 0,
currentTabType: 'all',
tabs: [

{
key: 0,
type: "all",
name: "全部",
number: 0
},

{
key: 1,
type: "audit",
name: "待审核",
number: 1
},

{
key: 2,
type: "refund",
name: "待确认",
number: 2
},

{
key: 3,
type: "confirm",
name: "待退款",
number: 20
},

{
key: 4,
type: "check-in",
name: "待入住",
number: 1
}
]

}
},
methods: {
onItemClick(currentTab) {

this.currentTab = currentTab
this.currentTabType = this.tabs[this.currentTab].type



},
console() {
console.log('我发生了变化')
}
}
}



// WEBPACK FOOTER //
// ./src/pages/bnb/order/List.vue